// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".RegistrationScreen{background-image:linear-gradient(-225deg, rgba(232,33,114,0.8), rgba(249,207,14,0.8));min-height:100vh;display:flex;flex-direction:column}.RegistrationScreen .RegistrationContainer{height:100%}.RegistrationScreen .RegistrationContainer .Logo{width:40px;height:40px}.RegistrationScreen .ImageSlide{-o-object-fit:contain;object-fit:contain;max-width:100%}\n", ""]);
// Exports
module.exports = exports;
